import React from "react";

export default function Marquee({ items = [] }) {
    const row = (
        <>
            {items.map((item, i) => (
                <span key={i} className="flex items-center gap-8 pr-8">
                    <span className="font-display italic text-2xl sm:text-3xl text-paper/90 whitespace-nowrap">{item}</span>
                    <span className="w-2 h-2 rounded-full bg-amber shrink-0" />
                </span>
            ))}
        </>
    );
    return (
        <div className="marquee-band border-y border-white/10 bg-sheet py-5 overflow-hidden" data-testid="editorial-marquee">
            <div className="flex w-max animate-marquee">
                <div className="flex">{row}</div>
                <div className="flex" aria-hidden="true">{row}</div>
            </div>
        </div>
    );
}
